module.exports = __webpack_public_path__ + "media/thankyou_message_6.32e34a74.mp3";